import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TabRole, TabsService } from 'src/app/libs/components/tabs-host/tabs.service';
import { Bom, Workcenter, BomMaterial, DraftableStateTypes, EDraftableStateType, EOperationStateType, OperationStateTypeColors, ProcessSheetMaterials, ProcessSheetProduct, ProcessSheetRevision, ProcessSheets, Product, RoutingOperation, TId, WmsLocation, WmsZone, AlternativeProduct } from 'src/app/models';
import { AlertService } from 'src/app/services/alert.service';
import { MasterApiService } from 'src/app/services/master-api.service';
import { SelectionChangedEvent } from 'devextreme/ui/lookup';
import { ProcessSheetsBomAddComponent } from './components/process-sheets-boom-add/process-sheets-bom-add.component';
import {combineLatest, firstValueFrom, take, takeUntil} from 'rxjs';
import { GenericResource, createCustomStore } from 'src/app/resources';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ProcessSheetMaterialsAddComponent } from './components/process-sheet-materials-add/process-sheet-materials-add.component';
import { GlamResourceDirective } from 'src/app/libs/directives/glam-resource.directive';
import { ValueChangedEvent } from 'devextreme/ui/tag_box';
import {
  ProductPricesComponent
} from "../../../../products-operative-products/components/product-prices/product-prices.component";
import {
  ProductStockComponent
} from "../../../../products-operative-products/components/product-stock/product-stock.component";
import {
  ProductSubscribersComponent
} from "../../../../products-operative-products/components/product-subscribers/product-subscribers.component";
import {ProductsEditComponent} from "../../../../products-operative-products/products-edit/products-edit.component";
import {AclService} from "../../../../../../../libs/services/acl.service";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {
  ProductProcesSheetsComponent
} from "../../../../products-operative-products/product-proces-sheets/product-proces-sheets.component";
import {
  ProductSimulationsComponent
} from "../../../../products-operative-products/product-simulations/product-simulations.component";
import {GenericCrudEditComponent} from "../../../../../../../libs/components/generic-crud/generic-crud-edit.component";
import {ProductsProcessSheetsEditComponent} from "../../products-process-sheets-edit.component";



@Component({
    selector: 'app-process-sheet-materials',
    templateUrl: './process-sheet-materials.component.html',
    styleUrl: './process-sheet-materials.component.sass',
    standalone: false
})
export class ProcessSheetMaterialsComponent implements OnInit {
  async saveProducts(cell: any, e: any) {
    const data = cell.data;
    const field = cell.column.dataField;
    const value = e.value.map((item: any) => typeof item === 'object' ? item.id : item);
    data[field] = value;
    await firstValueFrom(this.materials!.put(data));
    this.gridDirective?.refresh();
  }

  @Input() processSheet?: ProcessSheets;
  @Input() product?: ProcessSheetProduct | null = null;
  boms = this.api.resources.product.boms;
  bomId?: TId;
  bom?: Bom;
  bomMaterial?:BomMaterial;
  materials?: GenericResource<BomMaterial>;
  addMaterial=ProcessSheetMaterialsAddComponent
  visibleQTooltipIndex: number | null = null;
  visibleWasteTooltipIndex: number | null = null;
  procesSheetRevisions?: GenericResource<ProcessSheetRevision>;
  bomRevisions?: any;
  revisionsPopupVisible = false;
  stateTypes: any;
  processSheetRs = this.api.resources.product.processSheets;
  editProcessSheetComponent = ProductsProcessSheetsEditComponent;
  @ViewChild(GlamResourceDirective)
  gridDirective?: GlamResourceDirective<BomMaterial>;
  revisionMaterials: ProcessSheetMaterials[] = [];
  currentRevisionMaterialsResource?: GenericResource<ProcessSheetMaterials>;
  revisionMaterialsResource?: GenericResource<ProcessSheetMaterials>;
  routingOperations: RoutingOperation[] = [];
  workcenters: Workcenter[] = [];
  isManinProduct: boolean = false;
  materialsStore: any;
  areValidGrid=false
  formats = this.api.resources.product.productFormats
  warehouses = this.api.resources.wms.warehouses;
  zones = this.api.resources.wms.zones;
  productsResource = this.api.resources.product.products;
  containerTypes = this.api.resources.wms.containerTypes;
  zoneFilter = (warehouseId: string) => {
    return (item: WmsZone) => item.warehouseId === warehouseId;
  };
  quantities: Record<number, number> = {};
  operationDialog = false;
  saveDialogEnabled = false;
  invalidRowIds = new Set<TId>();
  locations = this.api.resources.wms.locations;
  isDraft?: boolean;
  isBomDraft: boolean = false;


  @ViewChild('materialsGrid', { static: false }) materialsGrid?: DxDataGridComponent;


  states: {[key: number]: string} = {};
  readonly stateColors: {[key: number]: string} = {
    [EDraftableStateType.Draft]: OperationStateTypeColors[EOperationStateType.Complete],
    [EDraftableStateType.Active]: OperationStateTypeColors[EOperationStateType.Start],
    [EDraftableStateType.Inactive]: OperationStateTypeColors[EOperationStateType.Complete],
    [EDraftableStateType.Obsolete]: OperationStateTypeColors[EOperationStateType.Complete],
  };


  constructor(private api: MasterApiService, private tr: TranslateService, private tabsService: TabsService, private acl: AclService, private tabs: TabsService, private alerts: AlertService) { }

  async ngOnInit(): Promise<void> {
    DraftableStateTypes.forEach(s => this.states[s.id] = this.tr.instant('enumeration.DraftableStateTypes.' + s.name));
    this.stateTypes = DraftableStateTypes;
    this.procesSheetRevisions = this.api.resources.product.processSheetsRevisions(this.processSheet!.processSheetId, this.processSheet!.versionId);
    this.boms = this.api.resources.product.boms.contextualizeQueryParams({
      documentTypeId: this.processSheet!.documentTypeId.toString()
    });

    if(this.processSheet?.bomId){
      this.bomId = this.processSheet.bomId;
      this.bom = await firstValueFrom(this.boms.get(this.bomId!));
      await this.getMaterials();
    }
    this.revisionMaterialsResource = this.api.resources.product.processSheetsRevisionMaterials(this.processSheet!.processSheetId, this.processSheet!.versionId, this.processSheet!.revisionId);
    this.revisionMaterials = await firstValueFrom(this.revisionMaterialsResource.getAll());
    if(this.processSheet!.routingId){
      this.routingOperations = await firstValueFrom(this.api.resources.product.routingOperations(this.processSheet!.routingId).getAll());
    }
    const product = await firstValueFrom(this.api.resources.product.products.get(this.processSheet!.productId));
    if(product.processSheetRevisionId === this.processSheet!.revisionId){
      this.isManinProduct = true;
    }
    this.workcenters = await firstValueFrom(this.api.resources.workcenters.getAll());
    this.isDraft = this.processSheet?.stateId === EDraftableStateType.Draft;
    this.isBomDraft = this.bom?.stateId === EDraftableStateType.Draft;
    this.materialsStore = createCustomStore({
      key: 'id',

      load: () => this.revisionMaterials,

      insert: (values) => {
        return firstValueFrom(this.revisionMaterialsResource!.post(values));
      },

      update: (values) => {
        return firstValueFrom(
          this.revisionMaterialsResource!.put(values)
        );
      },

      remove: (key): Promise<void> => {
        return firstValueFrom(
          this.revisionMaterialsResource!.delete(key)
        ).then(() => {});
      }
    });
  }

  hasPendingChanges(): boolean {
    const grid = this.materialsGrid?.instance;
    if (!grid) return false;

    const changes = grid.option('editing.changes') as Array<any>;
    return changes && changes.length > 0;
  }

  async closeOperationDialog() {
    let confirmed = true;
    if(this.hasPendingChanges()){
      confirmed = await this.alerts.confirm(this.tr.instant('common.unsavedChangesWarn'))
    }
    if(!confirmed){
      return
    } else {
      this.operationDialog = false;
      this.revisionMaterials = await firstValueFrom(this.revisionMaterialsResource!.getAll());
    }
  }

  getOperations(data: BomMaterial) {
    const operations: string[] = [];

    this.revisionMaterials?.forEach(m => {
      if (m.bomMaterialId === data.id) {
        this.routingOperations?.find(operation => {
          if (operation.id === m.routingOperationId) {
            operations.push(operation.name);
          }
        });
      }
    });

    if (operations.length === 0) {
      return '-';
    }
    return operations.join(', ');

  }

  async refreshProductsMap(){
    await firstValueFrom(this.api.calculateTree(this.processSheet!.productId))
  }


  async onBomChange($event: SelectionChangedEvent) {
    if (this.procesSheetRevisions) {
      const revision = await firstValueFrom(this.procesSheetRevisions.get(this.processSheet!.revisionId!));
      revision!.bomId = this.bomId!;
      await firstValueFrom(this.procesSheetRevisions.put(revision));
    }
    this.bom = await firstValueFrom(this.boms.get(this.bomId!));
    this.isBomDraft = this.bom?.stateId === EDraftableStateType.Draft;
    await this.getMaterials();
  }

  async getMaterials() {
    if (!this.bomId) return;
    this.materials = this.api.resources.product.bomMaterials(this.bomId);
    this.gridDirective?.changeResource(this.materials);
    this.gridDirective?.refresh();
  }

  async updateElement(cell: any, e: any) {
    const data = cell.data;
    const field = cell.column.dataField;
    data[field] = e.value;
    data.alternativeProducts = data.alternativeProducts
      ?.map((p: { id: TId; }) => typeof p === 'object' ? p.id : p)
      .filter(Boolean);

    if(!data.waste){
      data.waste = '0';
    }
    await firstValueFrom(this.materials!.put(data));
    this.gridDirective?.refresh();
  }


  async addBom() {
    if(!this.isDraft) return;
    const tab = this.tabsService.createTab(ProcessSheetsBomAddComponent, TabRole.CREATION, {
      inputPrms: {
        processSheet: this.processSheet,
      }
    });
    tab.component.instance.entityCreated.pipe(
        takeUntil(combineLatest([tab.destroy$])),
      ).subscribe((bom) => {
        this.bomId = (bom as Bom).id
        this.tabsService.closeTab(tab);
      });
  }

  openRevisions(): void {
    if (!this.bomId) return;
    // Filter the revisions by the selected bom on the backend.
    this.bomRevisions = this.api.resources.product.processSheets.contextualizeQueryParams({
      bomId: this.bomId.toString(),
    });
    this.revisionsPopupVisible = true;
  }

  navigateToProcessSheetEditor(element: ProcessSheets) {
    // Close the popup first and defer the tab creation a tick, so the dx-popup
    // overlay (rendered on document.body) is torn down before this component is
    // switched to an inactive tab. Otherwise the overlay lingers and blocks the UI.
    this.revisionsPopupVisible = false;
    setTimeout(() => {
      this.tabsService.createTab<GenericCrudEditComponent<ProcessSheets>>(this.editProcessSheetComponent!, TabRole.EDITION, { inputPrms: { entity: element } });
    });
  }

  async copyBom(){
    try {
      const bom = await firstValueFrom(this.api.bomClone(this.bomId!));
      const revision = await firstValueFrom(this.procesSheetRevisions!.get(this.processSheet!.revisionId!));
      revision!.bomId = this.bomId!;
      await firstValueFrom(this.procesSheetRevisions!.put(revision!));
      this.bomId = bom.id;
      this.alerts.info(this.tr.instant('entity.processSheets.bomCopied'));
    } catch (error) {
      console.log(error);
    }
  }

  locationFilter = (zoneId: string) => {
    return (item: WmsLocation) => item.zoneId === zoneId;
  };


  async updateWarehouseZoneOrContainer(cell: any, e: any) {
    const value = e.value;
    const items = e.component.option('items');
    let text = '';
    if(items && items.length > 0) {
       text = items.find((item: any) => item.id === value)?.name || '';
    }
    const field = cell.column.dataField; // campo de la columna
    const data = cell.data;
    if(field === 'warehouseId') {
      data['warehouseId'] = value;
      data['warehouseName'] = text;
      if (data['zoneId'] !== null) {
        data['zoneId'] = null;
        data['zoneName'] = null;
        this.gridDirective?.grid.instance.cellValue(data, 'zoneId', null);
      }
    }
    if(field === 'zoneId') {
      data['zoneId'] = value;
      data['zoneName'] = text;
    }
    if(field === 'locationId') {
      data['locationId'] = value;
      data['locationCode'] = items.find((item: any) => item.id === value)?.code || '';
      data['locationDescription'] = items.find((item: any) => item.id === value)?.description || '';
    }
    if(field === 'containerProductFormatId') {
      data['containerProductFormatId'] = value;
      data['containerProductFormatCode'] = items.find((item: any) => item.id === value)?.formatCode || '';
    }
    if(field === 'containerTypeId') {
      data['containerTypeId'] = value;
      data['containerTypeName'] = text;
    }
    if(field === 'containerOccupancy') {
      data['containerOccupancy'] = value;
    }
    if(data['warehouseId'] !== null && data['zoneId'] !== null && data['containerTypeId'] !== null && data['containerOccupancy'] !== null && data['containerProductFormatId']!== null) {
      await this.saveWarehouseZoneOrContainer(data);
    }
    if(!data['warehouseId']&& !data['zoneId']&& !data['containerTypeId']&& (!data['containerOccupancy']) && (!data['containerProductFormatId'])) {
      data['containerOccupancy'] = null;
      await this.saveWarehouseZoneOrContainer(data);
    }
  }

  async saveWarehouseZoneOrContainer(data:any) {
    try {
      await firstValueFrom(this.materials!.put(data));
    } catch (error:any) {
      this.alerts.error(error.error.message);
      return;
    }

    this.gridDirective?.grid.instance.closeEditCell();
    await this.gridDirective?.grid.instance.saveEditData();
    this.gridDirective?.grid.instance.refresh();
  }

  onCellPrepared(e: any) {
    if (e.rowType === 'data' && e.column) {
      const data = e.data;

      const allFilled =
        data.warehouseId &&
        data.zoneId &&
        data.containerTypeId &&
        data.containerOccupancy !== null;

      const noneFilled =
        !data.warehouseId &&
        !data.zoneId &&
        !data.containerTypeId &&
        data.containerOccupancy == null;

      if (!allFilled && !noneFilled) {
        this.invalidRowIds.add(data.id); // suponiendo que cada row tiene un `id`
      } else {
        this.invalidRowIds.delete(data.id);
      }
    }
  }


  async editOperations(data: BomMaterial) {
    if (!this.isDraft) return;

    this.bomMaterial = data;

    this.currentRevisionMaterialsResource =
      this.api.resources.product.processSheetsRevisionMaterials(
        this.processSheet!.processSheetId,
        this.processSheet!.versionId,
        this.processSheet!.revisionId
      ).contextualizeQueryParams({
        bomMaterialId: data.id.toString()
      });

    this.operationDialog = true;
  }

  openProduct(data: ProcessSheetProduct) {
    const productId = data.productId; // Extracting productId from data

    const innerEditors: any[] = [
      {
        name: 'price',
        component: ProductPricesComponent,
        inputPrms: { id: productId },
      },
      {
        name: 'stock',
        component: ProductStockComponent,
        inputPrms: { id: productId },
      },
      {
        name: 'processsheets',
        component: ProductProcesSheetsComponent,
        inputPrms: { productId: productId },
      },
      {
        name: 'simulations',
        component: ProductSimulationsComponent,
        inputPrms: { id: productId },
      },
    ];

    if (this.acl.isAdmin()) {
      innerEditors.push({
        name: 'subscribers',
        component: ProductSubscribersComponent,
        inputPrms: { id: productId },
        isAdminConfig: true,
      });
    }

    const cmpt = this.tabs.createTab(ProductsEditComponent, TabRole.EDITION, {
      inputPrms: {
        id: productId,
        innerEditors: innerEditors,
      },
    });

    cmpt.component.instance.entityChanged.pipe(take(1)).subscribe(() => {
      cmpt.close();
    });
  }

  async onSaving(e: DxDataGridTypes.SavingEvent) {
    if (!this.bomMaterial || !this.materialsGrid || !this.revisionMaterialsResource) return;

    e.cancel = true;

    const bomQty = Number(this.bomMaterial.quantity);
    const changes = e.changes ?? [];
    const getKey = (key: any) => key && typeof key === 'object' ? key.id : key;

    const removedKeys = new Set(
      changes
        .filter(c => c.type === 'remove')
        .map(c => getKey(c.key))
    );

    const currentRows = this.materialsGrid.instance
      .getVisibleRows()
      .filter(row => row.rowType === 'data')
      .filter(row => !row.isNewRow)
      .map(row => row.data as ProcessSheetMaterials)
      .filter(row => !removedKeys.has(row.id));

    const updatedRows = currentRows.map(row => {
      const change = changes.find(c =>
        c.type === 'update' &&
        getKey(c.key) === row.id
      );

      return {
        ...row,
        ...(change?.data ?? {})
      };
    });

    const insertedRows = changes
      .filter(c => c.type === 'insert')
      .map(c => ({
        ...c.data,
        bomMaterialId: this.bomMaterial!.id,
        quantity: Number(c.data.quantity ?? 0)
      } as Partial<ProcessSheetMaterials>));

    const finalRows: Array<Partial<ProcessSheetMaterials> & { id?: TId }> = [
      ...updatedRows,
      ...insertedRows
    ];

    const principalRow = finalRows[0];

    if (principalRow) {
      const sumOtherRows = finalRows
        .filter(row => row !== principalRow)
        .reduce((sum, row) => sum + Number(row.quantity || 0), 0);

      const principalQty = bomQty - sumOtherRows;

      if (principalQty < 0) {
        this.alerts.error(this.tr.instant('common.quantityNotCorrect'));
        return;
      }

      principalRow.quantity = principalQty;
    }

    e.promise = (async () => {
      try {
        for (const change of changes.filter(c => c.type === 'remove')) {
          await firstValueFrom(this.revisionMaterialsResource!.delete(getKey(change.key)));
        }

        for (const row of finalRows) {
          if (row.id) {
            await firstValueFrom(this.revisionMaterialsResource!.put(row));
          } else {
            await firstValueFrom(this.revisionMaterialsResource!.post(row));
          }
        }

        this.revisionMaterials = (await firstValueFrom(this.revisionMaterialsResource!.getAll()))
          .filter(r => r.bomMaterialId === this.bomMaterial!.id);

        e.component.cancelEditData();
        e.component.option('dataSource', this.revisionMaterials);
        await e.component.refresh(true);
      } catch (error: any) {
        this.alerts.error(error?.error?.message ?? error?.message ?? error);
      } finally {
        e.component.endCustomLoading?.();
        e.component.option('disabled', false);
        e.component.clearSelection();
        e.component.cancelEditData();
        e.component.repaint();
      }
    })();
  }

  onOperationMaterialInitNewRow(e: any) {
    const hasRows = (this.materialsGrid?.instance.getVisibleRows() ?? [])
      .some(row => row.rowType === 'data' && !row.isNewRow);

    e.data.bomMaterialId = this.bomMaterial!.id;
    e.data.quantity = hasRows ? 0 : Number(this.bomMaterial!.quantity);
  }

  protected readonly parseInt = parseInt;
  protected readonly parseFloat = parseFloat;
}
